import { useInstance } from '@meraki-internal/react-dependency-injection';
import { Redirect } from 'react-router';
import { OrganizationsState } from '../organizations/OrganizationsState';
import { AppPrincipal, isAnonymousViewer } from '../auth/AppPrincipal';
import { CareMapState } from '../caremap/CareMapState';
import { HistoryViewModel } from '../support/HistoryViewModel';

export const DefaultRouter: React.FC = () => {

    const isAnonymous = isAnonymousViewer(useInstance(AppPrincipal));

    const careMapState = useInstance(CareMapState);
    const caremap = careMapState.getMostRecentCaremap();

    const orgsState = useInstance(OrganizationsState);

    const history = useInstance(HistoryViewModel);

    let pathname: string;

    if (isAnonymous && caremap){
        // a link viewer came for the shared notes
        pathname = `/notes/${caremap.careMapId}`;
    }
    else if (orgsState.isOrgTeamMember()){
        pathname = `/org/${orgsState.getNonClientOrganizations()[0].orgId}`;
    }
    else {
        pathname = '/caregiver';
    }

    // redirect, preserving query params
    return <Redirect to={{
        ...history.getCurrentLocation(),
        pathname
    }} />;
};
